









































import BaseComponent from '@/components/base-component.vue';
import ArrayUtils from '@/helpers/arrayUtils';
import PatientModel from '@/models/patient-model';
import { checkUserPermissions } from '@/services/auth';
import { getPatientsCombo } from '@/services/patients';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { BehaviorSubject } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PatientForm from '../patients/patient-form.vue';
import PermissionAuth from './permission-auth.vue';

@Component({
  components: {
    PermissionAuth,
    PatientForm
  }
})
export default class UiAutocomplePatients extends BaseComponent {
  @Prop()
  public value: any;

  @Prop({ default: 'Paciente' })
  public label?: string;

  @Prop({ default: 'Escolha o paciente' })
  public placeholder?: string;

  @Prop()
  public required?: boolean;

  @Prop()
  public disabled?: boolean;

  @Prop({ default: false })
  public showAddPatient?: boolean;

  @Prop({ default: false })
  public addInactiveOnly?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  @Prop({ default: false })
  public multiple?: boolean;

  @Prop({ default: false })
  public chips?: boolean;

  @Prop({ default: false })
  public deletableChips?: boolean;

  @Prop({ default: null })
  public clientUnitsIds?: number[];

  @Prop({ default: null })
  public clientsIds?: number[];

  @Prop({ default: false })
  public immediate?: boolean;

  @Prop({ default: false })
  public showPatientsEmptyClient?: boolean;

  @Prop({ default: false })
  public showIcon?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop()
  public hint?: string;

  @Prop({ default: false })
  public persistentHint?: boolean;

  public loading: boolean = false;

  public paciente = null;
  public pacientes = [];

  private formPatientOpen = false;
  private subsidiary = null;
  private editPatient = null;

  searchInput = null;
  selecting = false;
  loadingValue = false;
  idFind = null;
  private bs$: BehaviorSubject<any> = null;

  created() {
    this.buildBs();
  }

  buildBs() {
    this.bs$ = this.buildBehaviorSubject(
      (f) => {
        return getPatientsCombo(this.getSanitizedSearchInput(), this.clientUnitsIds, this.clientsIds, this.idFind);
      },
      () => (this.loading = true),
      300,
      (res) => {
        this.pacientes = res.map((i) => {
          return { ...i, itemText: i.nome + ' - n. ' + i.nascimentoFmt };
        });
        this.loading = false;
        this.selectPaciente(this.value);
      },
      (error) => {
        this.loading = false;
        this.showToastApiError(error);
        this.buildBs();
      }
    );
  }

  mounted() {
    if (!!this.value || this.hasIdsClientOrIdsUnit()) {
      this.loadPatients();
    }
  }

  getSanitizedSearchInput() {
    if (!this.searchInput || !this.isUseSearchInput()) {
      return null;
    }
    if (this.searchInput.indexOf('-') != -1) {
      return this.searchInput.substring(0, this.searchInput.indexOf('-'));
    }
    return this.searchInput;
  }

  @Watch('searchInput')
  onSearchInputChange(s) {
    if (!this.isUseSearchInput()) {
      return;
    }
    if (this.selecting) {
      return;
    }
    this.idFind = null;
    if (!s && !!this.paciente) {
      this.onChange(null);
    }
    if (!s || s.length < 4) {
      this.pacientes = [];
      return;
    }
    this.loadPatients();
  }

  isUseSearchInput() {
    return !this.hasIdsClientOrIdsUnit();
  }

  hasIdsClientOrIdsUnit() {
    return (this.clientsIds && this.clientsIds.length) || (this.clientUnitsIds && this.clientUnitsIds.length);
  }

  public showNewPatientButton(): boolean {
    return this.showAddPatient && checkUserPermissions([PERMISSIONS_KEYS.PATIENT_INSERT]);
  }

  @Watch('value')
  public onChangeValue(val) {
    if (!val) {
      this.paciente = null;
      return;
    }
    this.idFind = this.getIdFind();
    if (!this.selecting) {
      this.loadPatients();
    }
  }

  getIdFind() {
    if (this.value == null) {
      return null;
    }
    if (this.hasIdsClientOrIdsUnit()) {
      return null;
    }
    return this.returnObject ? this.value.id : this.value;
  }

  public selectPaciente(val) {
    if (!val || !this.pacientes || !this.pacientes.length) {
      this.paciente = null;
      return;
    }

    let idx = this.pacientes.findIndex((p) => (this.returnObject ? p.id == val.id : p.id == val));
    if (idx != -1) {
      let pac = this.pacientes[idx];
      if (this.returnObject) {
        this.paciente = pac;
      } else {
        this.paciente = pac.id;
      }
    } else {
      this.onChange(null);
    }
  }

  @Watch('clientUnitsIds')
  public onClientUnitsIdsChange(clientUnitsIds, clientUnitsIdsOld) {
    if (ArrayUtils.equalsIgnoreOrder(clientUnitsIds, clientUnitsIdsOld)) {
      return;
    }
    this.pacientes = [];

    if (this.isUseSearchInput()) {
      this.onChange(null);
    } else {
      this.idFind = null;
      this.loadPatients();
    }
  }

  @Watch('clientsIds')
  public onClientsIdsChange(clientsIds, clientsIdsOld) {
    if (ArrayUtils.equalsIgnoreOrder(clientsIds, clientsIdsOld)) {
      return;
    }
    this.pacientes = [];

    if (this.isUseSearchInput()) {
      this.onChange(null);
    } else {
      this.idFind = null;
      this.loadPatients();
    }
  }

  public loadPatients(): void {
    this.bs$.next(true);
  }

  public onChange(val) {
    this.paciente = val;
    this.selecting = true;
    setTimeout(() => {
      this.selecting = false;
    }, 1000);
    if (!val && this.isUseSearchInput()) {
      this.pacientes = [];
    }
    this.$emit('input', val);
    this.$emit('change', val);
  }

  public newPatient(): void {
    this.formPatientOpen = true;
    this.editPatient = new PatientModel();
    if (this.addInactiveOnly === true) {
      this.editPatient.ativo = false;
    }
    this.subsidiary = this.clientUnitsIds && this.clientUnitsIds.length ? { id: this.clientUnitsIds[0] } : null;
  }

  public savePatientItem(patient: PatientModel): void {
    this.closePatientForm();
    this.paciente = patient;
    this.loadPatients();
    this.onChange(this.paciente);
  }

  public closePatientForm(): void {
    this.formPatientOpen = false;
  }
}
